import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../data/cakes';
import LoginModal from './LoginModal';
import './CakeCard.css';

const CakeCard = ({ cake, onAddToCart }) => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  
  // Initialize from localStorage
  const [isWishlisted, setIsWishlisted] = useState(() => {
    const user = localStorage.getItem('user_phone');
    if (!user) return false;
    const key = `wishlist_${user}`;
    const savedWishlist = JSON.parse(localStorage.getItem(key) || '[]');
    return savedWishlist.includes(cake.id);
  });

  const handleWishlist = () => {
    const user = localStorage.getItem('user_phone');
    console.log('Wishlist clicked. User:', user);
    
    if (!user) {
      console.log('Showing login modal');
      setShowLoginModal(true);
    } else {
      const newState = !isWishlisted;
      setIsWishlisted(newState);
      
      // Update localStorage with user-specific key
      const key = `wishlist_${user}`;
      const savedWishlist = JSON.parse(localStorage.getItem(key) || '[]');
      
      if (newState) {
        if (!savedWishlist.includes(cake.id)) {
          savedWishlist.push(cake.id);
        }
      } else {
        const index = savedWishlist.indexOf(cake.id);
        if (index > -1) {
          savedWishlist.splice(index, 1);
        }
      }
      localStorage.setItem(key, JSON.stringify(savedWishlist));
      
      // Optional: Sync with backend here if API available
    }
  };

  const handleCardClick = (e) => {
    // Prevent card click from triggering if wishlist button was clicked
    if (e.target.closest('.wishlist-btn')) {
      return;
    }
    onAddToCart(cake);
  };
  const totalPrice = cake.base_price + (cake.custom_design_fee || 0);
  const imageUrl = getImageUrl(cake.image);

  return (
    <>
      <div className="cake-card card fade-in" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
        <div className="cake-image-container">
          {imageUrl ? (
            <img src={imageUrl} alt={cake.title} className="cake-image" loading="lazy" />
          ) : (
            <div className="cake-placeholder gradient-secondary">
              <span className="cake-emoji">{cake.emoji || '🎂'}</span>
            </div>
          )}
          {cake.custom_design_fee > 0 && (
            <div className="custom-badge">
              <span>✨ Custom</span>
            </div>
          )}
          <img 
            src="/Veg_symbol.png" 
            alt="Veg" 
            className="veg-badge" 
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
        
        <div className="cake-content">
          <p className="cake-title">{cake.title}</p>
          
          <div className="cake-footer">
            <div className="cake-price">
              <span className="price-value">₹{totalPrice.toLocaleString()}</span>
            </div>
            <button 
               className={`wishlist-btn ${isWishlisted ? 'active' : ''}`}
               onClick={(e) => {
                 e.stopPropagation();
                 handleWishlist();
               }}
             >
               <svg 
               width="15" 
               height="15" 
               viewBox="0 0 24 24" 
               fill={isWishlisted ? "#e11d48" : "none"} 
               stroke={isWishlisted ? "#e11d48" : "#999"} 
               strokeWidth="2" 
               strokeLinecap="round" 
               strokeLinejoin="round"
             >
                 <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
               </svg>
             </button>
          </div>
          
          <div className="cake-meta">
            <div className="meta-item">
              <svg className="meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path>
              </svg>
              <span>{cake.base_weight}kg</span>
            </div>
            <div className="meta-item">
              <svg className="meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
              <span>{cake.serves_people}</span>
            </div>
          </div>
        </div>
      </div>
      
      {showLoginModal && (
        <LoginModal 
          onClose={() => setShowLoginModal(false)}
          onSuccess={() => {
            setIsWishlisted(true);
            // Persist wishlist logic here if needed
          }}
        />
      )}
    </>
  );
};

export default CakeCard;
